import React,{Component} from 'react'
import   './style.less';
import { connect } from 'react-redux';

@connect(
    state=>({user:state.user})
)
class Header extends Component{
    render(){
        return (
            <div className="headerContainer">
                <div className="logo">
                    <img alt={`麦迪文plus`} src={require('./../../static/img/logo.jpeg')} />
                </div>
                <div className="title">
                    <span>麦迪文PLUS</span>
                </div>
                <div className="userName">
                    <span>{this.props.user.userName}</span>
                </div>
            </div>
        )
    }
}


export default Header


// WEBPACK FOOTER //
// ./src/app/header/view.js